import { IonGrid, IonRow, IonCol } from "@ionic/react";

import "./StatCards.css";

interface StatCardsProps {
  members: number;
  notices: number;
  events: number;
  onNavigate: (tab: string) => void;
}

const StatCards: React.FC<StatCardsProps> = ({
  members,
  notices,
  events,
  onNavigate,
}) => {
  return (
    <IonGrid className="stat-cards">
      <IonRow>
        <IonCol size="4">
          <div
            className="stat-card stat-members"
            onClick={() => onNavigate("members")}
          >
            <span className="stat-value members">{members}</span>
            <span className="stat-label">Members</span>
          </div>
        </IonCol>
        <IonCol size="4">
          <div
            className="stat-card stat-notices"
            onClick={() => onNavigate("notices")}
          >
            <span className="stat-value notices">{notices}</span>
            <span className="stat-label">Notices</span>
          </div>
        </IonCol>
        <IonCol size="4">
          <div
            className="stat-card stat-events"
            onClick={() => onNavigate("calendar")}
          >
            <span className="stat-value events">{events}</span>
            <span className="stat-label">Upcoming Events</span>
          </div>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default StatCards;
